
import React, { useEffect, useState, useMemo } from 'react';
import {
  Box, Typography, Table, TableHead, TableBody, TableRow, TableCell,
  Checkbox, IconButton, CircularProgress, Stack, Card, CardContent, Tooltip,
  Divider, CardHeader, Snackbar, Button, useMediaQuery, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField
} from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import {
  Logout, Check, WarningAmber, NotificationsActive
} from '@mui/icons-material';
import api from '../../services/api-proxy';
import EventoApi from './EventoApi';
import AlertaModal from './AlertaModal';
import useSignalR from '../../hooks/useSignalR';
import usePushNotifications from '../../hooks/usePushNotifications';

const blink = keyframes`
  0% { background-color: transparent; }
  50% { background-color: rgba(255, 165, 0, 0.2); }
  100% { background-color: transparent; }
`;

const BlinkingTableRow = styled(TableRow)(({ blink: shouldBlink }) => ({
  ...(shouldBlink && {
    animation: `${blink} 1s infinite alternate`,
  }),
}));

const EventoKidsGerenciar = ({ eventoId }) => {
    usePushNotifications(); // ✅ Correto aqui
  const [kids, setKids] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [search, setSearch] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ open: false, message: '', severity: 'info' });
  const [filtroStatus, setFiltroStatus] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState({ open: false, onConfirm: null, message: '' });

  const confirmAction = (message, action) => {
    setConfirmDialog({ open: true, onConfirm: action, message });
  };

  const handleConfirm = () => {
    if (confirmDialog.onConfirm) confirmDialog.onConfirm();
    setConfirmDialog({ open: false, onConfirm: null, message: '' });
  };

  const handleCancel = () => {
    setConfirmDialog({ open: false, onConfirm: null, message: '' });
  };

  

  const fetchData = async () => {
    setLoading(true);
    try {
      const data = await EventoApi.listarKids(eventoId);
      setKids(data);
    } catch (error) {
      console.error('[EventoKidsGerenciar] Carregar kids', error);
      setToast({ open: true, message: 'Carregar dados', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (eventoId) fetchData();
  }, [eventoId]);



  useEffect(() => {
    setSelectedIds(prev => prev.filter(id => kids.some(k => k.id === id)));
  }, [kids]);
  const signalrOptions = useMemo(() => ({
    grupos: [`web_${eventoId}`],
    eventos: [
      "receberAlerta",
      "confirmarCheckout",
      "checkoutSolicitado",
      "checkinEfetuado",
      "reloadKids"
    ],
    onEvent: (event, payload) => {
      switch (event) {
        case "receberAlerta":
          console.log("🔔 Evento: receberAlerta", payload);
          setKids(prev =>
            prev.map(k =>
              k.id === payload?.dependenteId || k.id === payload?.id
                ? { ...k, dataUltimoAlerta: new Date().toISOString() }
                : k
            )
          );
          break;
        case "confirmarCheckout":
          console.log("🔁 Evento: confirmarCheckout", payload);
          setKids(prev =>
            prev.map(k =>
              k.id === payload
                ? { ...k, status: 'Saiu', presente: false, horaCheckOut: new Date().toISOString() }
                : k
            )
          );
          break;
        case "checkoutSolicitado":
          console.log("📤 Evento: checkoutSolicitado", payload);
          setKids(prev =>
            prev.map(k =>
              k.id === payload?.id
                ? {
                    ...k,
                    status: 'Checkout Solicitado',
                    horaCheckoutSolicitado: payload.horaCheckoutSolicitado || new Date().toISOString()
                  }
                : k
            )
          );
          break;
        case "checkinEfetuado":
          console.log("✅ Evento: checkinEfetuado", payload);
          setKids(prev =>
            prev.map(k =>
              k.id === payload?.id
                ? {
                    ...k,
                    status: payload.status || 'Presente',
                    presente: true,
                    horaCheckIn: payload.horaCheckIn || new Date().toISOString(),
                    horaCheckOut: null,
                    horaCheckoutSolicitado: null
                  }
                : k
            )
          );
          break;
        case "reloadKids":
          console.log("♻️ Evento: reloadKids");
          fetchData();
          break;
      }
    }
  }), [eventoId]);

  useSignalR("/hub/alertas", signalrOptions);

  const kidsFiltrados = useMemo(() => {
    return [...kids]
      .filter(k =>
        k.nome.toLowerCase().includes(search.toLowerCase()) &&
        (!filtroStatus ||
          (filtroStatus === 'Alerta' && k.presente && k.dataUltimoAlerta) ||
          (filtroStatus !== 'Alerta' && (k.status || 'Presente') === filtroStatus))
      )
      .sort((a, b) => {
        const prioridade = (kid) => {
  if (kid.dataUltimoAlerta && kid.presente) return 1; // Alerta ativo primeiro
  if (kid.status === 'Checkout Solicitado') return 2;
  if (kid.presente) return 3;
  return 4;
};

        const diff = prioridade(a) - prioridade(b);
        if (diff !== 0) return diff;
        if (prioridade(a) === 3) {
          return new Date(b.horaCheckIn || 0).getTime() - new Date(a.horaCheckIn || 0).getTime();
        }
        return 0;
      });
  }, [kids, search, filtroStatus]);
  const totalKids = kids.length;
  const totalPresentes = kids.filter(k => k.presente).length;
  const totalAlertas = kids.filter(k => k.presente && k.dataUltimoAlerta).length;
  const totalSaiu = kids.filter(k => k.status === 'Saiu').length;

  const confirmarCheckout = async (kidId) => {
    try {
      await api.post(`/api/Eventos/${eventoId}/Kids/${kidId}/confirmar-checkout`);
      fetchData();
    } catch (err) {
      setToast({ open: true, message: 'Confirmar checkout', severity: 'error' });
    }
  };

  const solicitarCheckout = async (kidId) => {
    try {
      await api.post(`/api/Eventos/${eventoId}/Kids/${kidId}/solicitar-checkout`);
      fetchData();
    } catch (err) {
      setToast({ open: true, message: 'Solicitar checkout', severity: 'error' });
    }
  };

const limparAlertaIndividual = async (kid) => {
  try {
    await api.post(`/api/Eventos/${eventoId}/limpar-alerta/${kid.id}`);
    setKids(prev => prev.map(k =>
      k.id === kid.id ? { ...k, dataUltimoAlerta: null } : k
    ));
    setToast({ open: true, message: `Alerta de ${kid.nome} removido.`, severity: 'info' });
  } catch (err) {
    setToast({ open: true, message: 'Remover alerta.', severity: 'error' });
  }
};


const limparAlertas = async () => {
  try {
    // Limpa no banco de dados
    await EventoApi.limparAlertas(eventoId);

    // Atualiza estado local (remover alerta de todos os kids)
    setKids(prev => prev.map(k => ({ ...k, dataUltimoAlerta: null })));

    // Opcional: emitir evento via SignalR se desejar que outros conectados recarreguem
    // await api.post(`/api/Eventos/${eventoId}/emitir-alerta`, {
    //   tipo: 'LimpezaGlobal', // pode ignorar ou remover esse payload
    // });

    setToast({ open: true, message: 'Alertas limpos', severity: 'info' });
  } catch (err) {
    setToast({ open: true, message: 'Não se aplica', severity: 'error' });
  }
};

const enviarAlerta = async () => {
  console.log('🟡 INICIANDO ENVIO DE ALERTA');

  try {
    // Filtra apenas os kids selecionados que estão presentes
    const presentes = kids.filter(k => selectedIds.includes(k.id) && k.presente);
    console.log('➡️ Kids Selecionados:', selectedIds);
    console.log('✅ Kids Presentes:', presentes.map(k => k.nome));

    // Verifica se há kids presentes selecionados
    if (presentes.length === 0) {
      setToast({
        open: true,
        message: 'Selecione ao menos um dependente presente.',
        severity: 'warning'
      });
      return;
    }

    // Verifica se a mensagem foi preenchida
    if (!mensagem || mensagem.trim().length < 2) {
      setToast({
        open: true,
        message: 'Digite uma mensagem para o alerta.',
        severity: 'warning'
      });
      return;
    }

    // Envia o alerta individualmente para cada responsável via push
    const results = await Promise.allSettled(
      presentes.map(k => {
        if (k?.usuarioPwaId) {
          console.log(`📤 Enviando alerta para ${k.nome} (${k.usuarioPwaId})`);
          return api.post(`/api/push/enviar/usuario/${k.usuarioPwaId}`, {
            titulo: 'Alerta do evento',
            mensagem,
            url: '/pwa/kids'
          });
        } else {
          console.warn(`⚠️ ${k.nome} não possui usuarioPwaId — ignorado`);
          return Promise.resolve(); // ignora quem não tem usuário
        }
      })
    );

    // Verifica falhas
    const falhas = results.filter(r => r.status === 'rejected');
    if (falhas.length > 0) {
      console.warn('❌ Falha ao enviar para alguns usuários:', falhas);
      setToast({
        open: true,
        message: `⚠️ Enviado com erros: ${falhas.length} falharam.`,
        severity: 'warning'
      });
    } else {
      console.log('✅ Todos os alertas foram enviados com sucesso.');
      setToast({
        open: true,
        message: '✅ Alertas enviados com sucesso.',
        severity: 'success'
      });
    }

    // Limpa modal e campo de mensagem
    setModalOpen(false);
    setMensagem('');
  } catch (err) {
    console.error('❌ Erro geral no envio de alerta:', err);
    setToast({
      open: true,
      message: 'Erro ao enviar alerta.',
      severity: 'error'
    });
  }
};



  const enviarAlertaTeste = async () => {
    try {
      await api.post(`/api/push/enviar/usuario/self`, {
        titulo: '🔔 MIF LISBOA',
        mensagem: 'A Paz do Senhor!',
        url: '/pwa/kids'
      });
      setToast({ open: true, message: 'Push de teste enviado.', severity: 'success' });
    } catch (err) {
      setToast({ open: true, message: 'Testar push', severity: 'error' });
    }
  };

  const marcarTodos = () => setSelectedIds(kidsFiltrados.map(k => k.id));
  const desmarcarTodos = () => setSelectedIds([]);
  const toggleSelect = (id) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };
  return (
    <Box p={2} sx={{ bgcolor: '#f4f6f8', minHeight: '100vh' }}>
      <Card elevation={3}>
        <CardHeader
          title={<Typography variant="h6">Gestão de Dependentes</Typography>}
          subheader="Visualize, alerte ou execute ações com os kids ao vivo"
         action={
  <Box display="flex" alignItems="center" gap={1}>

    <Tooltip title="Enviar Push de Teste">

      <IconButton onClick={enviarAlertaTeste}>
        <NotificationsActive />
      </IconButton>

    </Tooltip>
    {/* <Typography variant="caption" sx={{ color: 'text.disabled', maxWidth: 250, wordBreak: 'break-all' }}>
      {eventoId}
    </Typography> */}

  </Box>
}

        />
        <Divider />
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} flexWrap="wrap" gap={2}>
            {/* Ações */}
            <Stack direction="row" spacing={2}>
              <Button variant="outlined" onClick={marcarTodos}>Marcar Todos</Button>
              <Button variant="outlined" onClick={desmarcarTodos}>Desmarcar Todos</Button>
              <Button variant="contained" color="warning" onClick={() => setModalOpen(true)} startIcon={<NotificationsActive />}>Enviar Alerta</Button>
              <Button variant="contained" color="error" onClick={limparAlertas}>Limpar Alertas</Button>
              <Button
  variant="contained"
  color="primary"
  onClick={() =>
    confirmAction("Tem certeza que deseja finalizar o evento? Todos os dependentes devem estar com status 'Saiu'.", async () => {
      try {
        await EventoApi.finalizarEvento(eventoId);
        setToast({ open: true, message: 'Evento finalizado com sucesso.', severity: 'success' });
        fetchData();
      } catch (err) {
        setToast({ open: true, message: err.message || 'Finalizar evento.', severity: 'error' });
      }
    })
  }
>
  Finalizar Evento
</Button>


            </Stack>

            {/* Totais */}
            <Stack direction="row" spacing={4} alignItems="center">
              <Box textAlign="center" sx={{ cursor: 'pointer' }} onClick={() => setFiltroStatus(null)}>
                <Typography variant="h6">{totalKids}</Typography>
                <Typography variant="caption" color="textSecondary">Total Kids</Typography>
              </Box>
              <Box textAlign="center" sx={{ cursor: 'pointer' }} onClick={() => setFiltroStatus('Presente')}>
                <Typography variant="h6" color="success.main">{totalPresentes}</Typography>
                <Typography variant="caption" color="textSecondary">Presentes</Typography>
              </Box>
              <Box textAlign="center" sx={{ cursor: 'pointer' }} onClick={() => setFiltroStatus('Alerta')}>
                <Typography variant="h6" color="warning.main">{totalAlertas}</Typography>
                <Typography variant="caption" color="textSecondary">Com Alerta</Typography>
              </Box>
              <Box textAlign="center" sx={{ cursor: 'pointer' }} onClick={() => setFiltroStatus('Saiu')}>
                <Typography variant="h6" color="text.disabled">{totalSaiu}</Typography>
                <Typography variant="caption" color="textSecondary">Saiu</Typography>
              </Box>
            </Stack>
          </Box>

          {/* Tabela */}
          {loading ? (
            <Box display="flex" justifyContent="center" py={6}>
              <CircularProgress size={60} />
            </Box>
          ) : (
            <Table size="medium">
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedIds.length === kidsFiltrados.length}
                      indeterminate={selectedIds.length > 0 && selectedIds.length < kidsFiltrados.length}
                      onChange={(e) => e.target.checked ? marcarTodos() : desmarcarTodos()}
                    />
                  </TableCell>
                  <TableCell>Nome</TableCell>
                  <TableCell>Responsável</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Alerta</TableCell>
                  <TableCell>Check-in</TableCell>
                  <TableCell>Check-out</TableCell>
                  <TableCell align="center" colSpan={3}><Typography fontWeight="bold">Ações</Typography></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {kidsFiltrados.map((kid) => (
                  <BlinkingTableRow key={kid.id} hover blink={kid.dataUltimoAlerta && kid.presente}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedIds.includes(kid.id)}
                        onChange={() => toggleSelect(kid.id)}
                      />
                    </TableCell>
                    <TableCell>{kid.nome}</TableCell>
                    <TableCell>{kid.responsavelNome || '-'}</TableCell>
                    <TableCell>{kid.responsavelTelefone || '-'}</TableCell>
                    <TableCell>{kid.status || "Presente"}</TableCell>
                    <TableCell>{kid.dataUltimoAlerta ? "🔔" : "-"}</TableCell>
                    <TableCell>{kid.horaCheckIn ? new Date(kid.horaCheckIn).toLocaleTimeString() : '-'}</TableCell>
                    <TableCell>{kid.horaCheckOut ? new Date(kid.horaCheckOut).toLocaleTimeString() : '-'}</TableCell>
                    <TableCell align="center">
                      <Tooltip title="Solicitar checkout">
                        <IconButton onClick={() => solicitarCheckout(kid.id)}><Logout /></IconButton>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Confirmar checkout">
                        <IconButton onClick={() => confirmarCheckout(kid.id)}><Check /></IconButton>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Emitir alerta">
                       
                       
              <IconButton
  onClick={async () => {
    if (!kid.presente) {
      setToast({ open: true, message: 'Apenas presentes podem receber alerta.', severity: 'warning' });
      return;
    }

    if (kid.dataUltimoAlerta) {
      confirmAction(`Deseja remover o alerta de ${kid.nome}?`, () => limparAlertaIndividual(kid));
    } else {
      try {
        await api.post(`/api/Eventos/${eventoId}/emitir-alerta/${kid.id}`);
        setKids(prev => prev.map(k =>
          k.id === kid.id ? { ...k, dataUltimoAlerta: new Date().toISOString() } : k
        ));
        setToast({ open: true, message: 'Alerta emitido', severity: 'info' });
      } catch (err) {
        setToast({ open: true, message: 'Emitir alerta.', severity: 'error' });
      }
    }
  }}
>
  <WarningAmber />
</IconButton>

                      </Tooltip>
                    </TableCell>
                  </BlinkingTableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>

      <AlertaModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        mensagem={mensagem}
        setMensagem={setMensagem}
        onEnviar={enviarAlerta}
      />

      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={() => setToast({ ...toast, open: false })}
        message={toast.message}
      />
      <Dialog open={confirmDialog.open} onClose={handleCancel}>
  <DialogTitle>Confirmação</DialogTitle>
  <DialogContent>
    <Typography>{confirmDialog.message}</Typography>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCancel}>Cancelar</Button>
    <Button onClick={handleConfirm} variant="contained" color="primary">Confirmar</Button>
  </DialogActions>
</Dialog>

    </Box>
  );
};

export default EventoKidsGerenciar;

